import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './profA2InitialState';
import {
  _setCommentOnRecommendations,
  _setDateSigned,
  _setDayTreatment,
  _setDrug1AgeFirstUsed,
  _setDrug1FrequencyId,
  _setDrug1InTakeId,
  _setDrug1UsedId,
  _setDrug2AgeFirstUsed,
  _setDrug2FrequencyId,
  _setDrug2InTakeId,
  _setDrug2UsedId,
  _setDrug3AgeFirstUsed,
  _setDrug3FrequencyId,
  _setDrug3InTakeId,
  _setDrug3UsedId,
  _setDrug4AgeFirstUsed,
  _setDrug4FrequencyId,
  _setDrug4InTakeId,
  _setDrug4UsedId,
  _setFOTEP,
  _setIsProfA2DataLoaded,
  _setLengthofTimeSinceClientLastUsed,
  _setNotReferredInappropriate,
  _setNotReferredRefusingTreatment,
  _setOutPatient,
  _setProgram1Completed,
  _setProgram1Modality,
  _setProgram1Name,
  _setProgram1TreatmentLength,
  _setProgram1Year,
  _setProgram2Completed,
  _setProgram2Modality,
  _setProgram2Name,
  _setProgram2TreatmentLength,
  _setProgram2Year,
  _setProgram3Completed,
  _setProgram3Modality,
  _setProgram3Name,
  _setProgram3TreatmentLength,
  _setProgram3Year,
  _setProgramTransitionalStaffId,
  _setRecommendResidentialWithChild,
  _setRecommendSoberLivingWithChild,
  _setRecommendSoberLivingWithIntensiveOdf,
  _setReferredForTreatment,
  _setResidential,
  _setSoberLiving,
  _setTimeSpentinInstitutions,
  _setTreatmentAccomplishments,
} from './profA2ModelActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfA2Form = createAsyncThunk(
  'stop/getProfA2Form',
  async (params) => {
    const { profA2TabUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(profA2TabUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const profA2Slice = createSlice({
  name: 'stop/profA2',
  initialState,
  reducers: {
    setDrug1UsedId: _setDrug1UsedId,
    setDrug2UsedId: _setDrug2UsedId,
    setDrug3UsedId: _setDrug3UsedId,
    setDrug4UsedId: _setDrug4UsedId,
    setDrug1InTakeId: _setDrug1InTakeId,
    setDrug2InTakeId: _setDrug2InTakeId,
    setDrug3InTakeId: _setDrug3InTakeId,
    setDrug4InTakeId: _setDrug4InTakeId,
    setDrug1FrequencyId: _setDrug1FrequencyId,
    setDrug2FrequencyId: _setDrug2FrequencyId,
    setDrug3FrequencyId: _setDrug3FrequencyId,
    setDrug4FrequencyId: _setDrug4FrequencyId,
    setDrug1AgeFirstUsed: _setDrug1AgeFirstUsed,
    setDrug2AgeFirstUsed: _setDrug2AgeFirstUsed,
    setDrug3AgeFirstUsed: _setDrug3AgeFirstUsed,
    setDrug4AgeFirstUsed: _setDrug4AgeFirstUsed,
    setLengthofTimeSinceClientLastUsed: _setLengthofTimeSinceClientLastUsed,
    setTimeSpentinInstitutions: _setTimeSpentinInstitutions,
    setProgram1Name: _setProgram1Name,
    setProgram2Name: _setProgram2Name,
    setProgram3Name: _setProgram3Name,
    setProgram1Modality: _setProgram1Modality,
    setProgram2Modality: _setProgram2Modality,
    setProgram3Modality: _setProgram3Modality,
    setProgram1Year: _setProgram1Year,
    setProgram2Year: _setProgram2Year,
    setProgram3Year: _setProgram3Year,
    setProgram1Completed: _setProgram1Completed,
    setProgram2Completed: _setProgram2Completed,
    setProgram3Completed: _setProgram3Completed,
    setProgram1TreatmentLength: _setProgram1TreatmentLength,
    setProgram2TreatmentLength: _setProgram2TreatmentLength,
    setProgram3TreatmentLength: _setProgram3TreatmentLength,
    setTreatmentAccomplishments: _setTreatmentAccomplishments,
    setReferredForTreatment: _setReferredForTreatment,
    setNotReferredInappropriate: _setNotReferredInappropriate,
    setNotReferredRefusingTreatment: _setNotReferredRefusingTreatment,
    setResidential: _setResidential,
    setSoberLiving: _setSoberLiving,
    setOutPatient: _setOutPatient,
    setDayTreatment: _setDayTreatment,
    setRecommendResidentialWithChild: _setRecommendResidentialWithChild,
    setRecommendSoberLivingWithChild: _setRecommendSoberLivingWithChild,
    setRecommendSoberLivingWithIntensiveOdf:
      _setRecommendSoberLivingWithIntensiveOdf,
    setFOTEP: _setFOTEP,
    setCommentOnRecommendations: _setCommentOnRecommendations,
    setProgramTransitionalStaffId: _setProgramTransitionalStaffId,
    setDateSigned: _setDateSigned,
    setIsProfA2DataLoaded: _setIsProfA2DataLoaded,
    //resetProfA2: () => null,
  },
  extraReducers: {
    [getProfA2Form.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setDrug1UsedId,
  setDrug2UsedId,
  setDrug3UsedId,
  setDrug4UsedId,
  setDrug1InTakeId,
  setDrug2InTakeId,
  setDrug3InTakeId,
  setDrug4InTakeId,
  setDrug1FrequencyId,
  setDrug2FrequencyId,
  setDrug3FrequencyId,
  setDrug4FrequencyId,
  setDrug1AgeFirstUsed,
  setDrug2AgeFirstUsed,
  setDrug3AgeFirstUsed,
  setDrug4AgeFirstUsed,
  setLengthofTimeSinceClientLastUsed,
  setTimeSpentinInstitutions,
  setProgram1Name,
  setProgram2Name,
  setProgram3Name,
  setProgram1Modality,
  setProgram2Modality,
  setProgram3Modality,
  setProgram1Year,
  setProgram2Year,
  setProgram3Year,
  setProgram1Completed,
  setProgram2Completed,
  setProgram3Completed,
  setProgram1TreatmentLength,
  setProgram2TreatmentLength,
  setProgram3TreatmentLength,
  setTreatmentAccomplishments,
  setReferredForTreatment,
  setNotReferredInappropriate,
  setNotReferredRefusingTreatment,
  setResidential,
  setSoberLiving,
  setOutPatient,
  setDayTreatment,
  setRecommendResidentialWithChild,
  setRecommendSoberLivingWithChild,
  setRecommendSoberLivingWithIntensiveOdf,
  setFOTEP,
  setCommentOnRecommendations,
  setProgramTransitionalStaffId,
  setDateSigned,
  setIsProfA2DataLoaded,
  //resetProfA2
} = profA2Slice.actions;

export default profA2Slice.reducer;
